module.exports = __webpack_public_path__ + "media/images/icons/aperture-1c9d50191239ca36173a25c134f02357.svg";